// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Title: 'title',
	Button: 'button',
	Button2: 'button-2',
} as const;
